var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{style:(_vm.style),attrs:{"color":_vm.hexColor(_vm.getObjectStateBackgroundColor(_vm.item.main_object_state)),"dark":_vm.isDarkColor(_vm.getObjectStateBackgroundColor(_vm.item.main_object_state)),"to":_vm.isHasManyField ? _vm.hasManyItemLink : '',"tabindex":"-1","label":""}},[_vm._v(" "+_vm._s(_vm.item.main_object_state.summary)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }